import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "@nxt-shared/ui/lib/utils";
const SIZE = {
    md: "size-7 rounded-md text-sm",
    sm: "size-5 rounded-sm text-xs",
    xs: "size-4 rounded-sm text-xs",
};
/**
 * The Organization's mark: its logo image when the listing supplies one, otherwise a letter
 * placeholder derived from the display name. Neither listing carries logos today, so this renders
 * the placeholder everywhere; the image path exists so real logos slot in without a layout change.
 */
export function OrgMark({ name, imageUrl, size = "md", className, }) {
    if (imageUrl) {
        return _jsx("img", { src: imageUrl, alt: "", className: cn("shrink-0 object-cover", SIZE[size], className) });
    }
    const letter = name.trim().charAt(0).toUpperCase() || "?";
    return (_jsx("span", { "aria-hidden": true, className: cn("inline-flex shrink-0 items-center justify-center bg-[color-mix(in_oklab,var(--secondary)_10%,var(--popover))] font-bold text-secondary-darkest select-none", SIZE[size], className), children: letter }));
}
//# sourceMappingURL=OrgMark.js.map